module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iOCIgZmlsbD0iI0VFRjJGRiIvPgo8cGF0aCBkPSJNMTQgMTYuNUwxNS41IDE4TDE4IDE0LjVNMTYgMTBDMTIuNjg4NSAxMCAxMCAxMi42ODg1IDEwIDE2QzEwIDE5LjMxMTUgMTIuNjg4NSAyMiAxNiAyMkMxOS4zMTE1IDIyIDIyIDE5LjMxMTUgMjIgMTZDMjIgMTIuNjg4NSAxOS4zMTE1IDEwIDE2IDEwWiIgc3Ryb2tlLXdpZHRoPSIxLjMzMzMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZT0iIzAwNTFERiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/rightCard.svg
// module id = SnLh
// module chunks = 1